import React from "react";
import {fbDatabaseService} from "../jwt/_services/firebase/fbDatabaseService";

export const fbDatabaseProvider = {
    getOptions,
    getItem,
};

async function getOptions(dataRequest){
    try {
        const result = await fbDatabaseService.search(0, 1000, dataRequest);

        return result.data.map((itemData) => {
            const { id, code } = itemData
            return (
                {
                    id: id,
                    value: code,
                    label: <div><label>{code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await fbDatabaseService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}